// extracted by mini-css-extract-plugin
export default {"mydiv":"MySlider_mydiv__miSPp","mydiv1":"MySlider_mydiv1__bkC6r","mydiv2":"MySlider_mydiv2__CmgpC","earnbtn":"MySlider_earnbtn__UeQDc","overlay":"MySlider_overlay__kNJhr"};